import { motion } from 'framer-motion';

/** Fade + scale reveal used when a generation result arrives. */
export default function ResultReveal({ children, className }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.96, y: 12 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ type: 'spring', stiffness: 220, damping: 24 }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
